<div
  class="image-modal-backdrop"
  *ngIf="isContentVisible"
  (click)="hideImage($event)"
>
  <div class="buttons">
    <button class="download-button" (click)="deleteMediaFunc(imageSrc)">
      <img src="assets/icons/delete-file.svg" alt="" /> Remover anexo
    </button>
    <button class="download-button" (click)="downloadContent()">
      <img src="assets/icons/download-file.svg" alt="" /> Baixar arquivo
    </button>
  </div>
</div>
<img
  *ngIf="isContentVisible && !isContentVideo"
  [src]="imageSrc"
  class="fullscreen-image"
/>
<video
  *ngIf="isContentVisible && isContentVideo"
  [src]="imageSrc"
  class="fullscreen-image"
  controls
  autoplay
></video>
<button
  *ngIf="isContentVisible"
  (click)="hideImageButton()"
  class="close-image-button"
>
  <mat-icon>close</mat-icon>
</button>

<div class="background">
  <div *ngIf="loading" class="spinner">
    <mat-spinner></mat-spinner>
  </div>
  <div *ngIf="!loading" class="container-fluid">
    <div
      class="row justify-content-center"
      style="max-width: 1300px; margin: 0 auto"
    >
      <div
        class="header"
        style="display: flex; gap: 30px; margin-top: 30px; padding: 0"
      >
        <div
          [routerLink]="'/home/ocurrences'"
          class="header-back"
          style="cursor: pointer"
        >
          <img src="assets/icons/arrowBack.svg" alt="" />
        </div>
        <div style="width: 100%">
          <h1
            style="
              color: var(--material-theme-ref-primary-primary-10, #180064);
              font-family: Roboto;
              font-size: 32px;
              font-style: normal;
              font-weight: 500;
              line-height: 40px;
            "
          >
            Ocorrência ID{{ denounceId }} -
            {{ formatarData(denounce.datetime).slice(0, 9) }}
          </h1>
        </div>
      </div>

      <section
        class="denounce-section"
        style="
          padding: 0;
          max-width: calc(100% - 74px);
          margin: 20px 0 0 auto;
          height: 100%;
        "
      >
        <div class="information-occurrence" style="display: flex; gap: 30px">
          <div
            style="flex: 0.5; gap: 25px; display: flex; flex-direction: column"
          >
            <div class="details-ocurrence">
              <div class="labels-details">
                <p class="label">Ocorrido em</p>
                <div class="content-label-ocurrence">
                  {{ formatarData(denounce.datetime) }}
                </div>
              </div>
              <div class="labels-details">
                <p class="label">Data do registro</p>
                <div class="content-label-ocurrence">
                  {{ formatarData(denounce.created_at) }}
                </div>
              </div>
              <div
                class="labels-details"
                style="justify-content: flex-end"
                *ngIf="emergency"
              >
                <div class="emergency-label">EMERGÊNCIA</div>
              </div>
            </div>

            <div
              id="map"
              style="width: 100%; height: 100%; border-radius: 16px"
            >
              <agm-map
                style="height: 309px"
                [latitude]="center.lat"
                [longitude]="center.lng"
                [zoom]="15"
                [zoomControl]="false"
                [streetViewControl]="false"
              >
                <agm-marker
                  [iconUrl]="'../../../../assets/images/pin.png'"
                  [latitude]="center.lat"
                  [longitude]="center.lng"
                ></agm-marker>
              </agm-map>
            </div>

            <div class="additional-information">
              <h3 class="title-label">DETALHES</h3>
              <div class="labels-additional">
                <p class="label">Ocorrido em</p>
                <div class="content-label content-label-ocurrence">
                  {{ translatePlace(denounce.place) }} -
                  {{
                    denounce.reference_point
                      ? denounce.reference_point
                      : denounce.sublocality
                  }}
                </div>
              </div>

              <div class="labels-additional">
                <p class="label">Tipo de agressão</p>
                <div
                  *ngFor="let type of denounce.type"
                  class="content-label-additional"
                >
                  {{ translateType(type) }}
                </div>
              </div>

              <div
                class="label-information"
                style="margin-top: 3rem; margin-bottom: 1.5rem"
              >
                <p class="label title-label">DADOS SOBRE A VÍTIMA</p>
              </div>

              <div class="d-flex flex-row align-items-center" *ngIf="superUser">
                <div class="label-information">
                  <p class="label title-label">Nome</p>
                  <div class="content-label">
                    {{ userName || "Não informado" }}
                  </div>
                </div>
                <div class="label-information">
                  <p class="label title-label">CPF</p>
                  <div class="content-label">
                    {{ userCPF || "Não informado" }}
                  </div>
                </div>
              </div>

              <div class="d-flex flex-row align-items-center" *ngIf="superUser">
                <div class="label-information">
                  <p class="label title-label">Telefone</p>
                  <div class="content-label">
                    {{ denounce?.user_data?.phone_number || "Não informado" }}
                  </div>
                </div>
                <div class="label-information">
                  <p class="label title-label">E-mail</p>
                  <div class="content-label">
                    {{ denounce?.user_data?.email || "Não informado" }}
                  </div>
                </div>
              </div>

              <div class="d-flex flex-row align-items-center">
                <div class="label-information">
                  <p class="label title-label">USUÁRIO</p>
                  <div class="content-label">{{ denounce.user_id }}</div>
                </div>
                <div class="label-information">
                  <p class="label title-label">SITUAÇÃO</p>
                  <div class="content-label">
                    {{ denounce?.complainer_type }}
                  </div>
                </div>
              </div>

              <div
                class="d-flex flex-row align-items-center flex-wrap"
                style="margin-top: 1.5rem"
              >
                <div class="label-information">
                  <p class="label title-label">GÊNERO</p>
                  <div class="content-label">
                    {{
                      detailsOcurrence.gender
                        ? detailsOcurrence.gender
                        : "Carregando..."
                    }}
                  </div>
                </div>
                <div class="label-information">
                  <p class="label title-label">ETNIA</p>
                  <div class="content-label">
                    {{
                      detailsOcurrence.race
                        ? detailsOcurrence.race
                        : "Carregando..."
                    }}
                  </div>
                </div>
                <div class="label-information">
                  <p class="label title-label">IDADE</p>
                  <div class="content-label">
                    {{
                      detailsOcurrence.age
                        ? detailsOcurrence.age
                        : "Carregando..."
                    }}
                  </div>
                </div>
                <div class="label-information">
                  <p class="label title-label">SEXUALIDADE</p>
                  <div class="content-label">
                    {{
                      detailsOcurrence.sexuality
                        ? detailsOcurrence.sexuality
                        : "Carregando..."
                    }}
                  </div>
                </div>
              </div>

              <div class="relato-container" style="margin-top: 2rem">
                <div class="relato-label title-label">RELATO</div>
                <div class="relato-content">{{ denounce.description }}</div>

                <span *ngIf="denounce.media.length > 0 || true"
                  >IMAGENS DO USUÁRIO</span
                >
                <div
                  class="relato-media"
                  *ngIf="denounce.media.length > 0 || true"
                >
                  <div class="media" style="width: 100%; max-width: 360px">
                    <div class="user-files-preview"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="flex: 0.5; margin-top: 70px">
            <div class="status-container">
              <div class="notes-label title-label">STATUS DO RELATO</div>
              <div class="header-container-input">
                <mat-form-field
                  id="select"
                  style="
                    width: 330px;
                    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
                    padding: 0;
                  "
                >
                  <mat-icon [ngStyle]="{ color: '#5B43D9' }" matSuffix
                    >keyboard_arrow_down</mat-icon
                  >
                  <mat-select
                    (change)="selectValueChange($event)"
                    [(value)]="selectedValue"
                  >
                    <mat-option value="">Selecionar...</mat-option>
                    <mat-option
                      *ngFor="let status of selectedStatus"
                      [value]="status"
                    >
                      {{ status.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <div (click)="putStatusDenounce()" class="button-1">
                  <p class="text-1">Atualizar</p>
                </div>
              </div>

              <div class="notes-label title-label">
                LINHA DO TEMPO DE STATUS
              </div>

              <hr style="background-color: #c8bfff; margin: 1rem 0" />

              <div class="timeline">
                <div
                  class="timeline-item"
                  *ngFor="let status of statusHistory; let i = index"
                >
                  <div class="timeline-badge">{{ i + 1 }}</div>
                  <div class="timeline-content">
                    <h3>{{ status.status.main }}</h3>
                    <div
                      class="d-flex flex-row align-items-start justify-content-between"
                      style="width: 70%"
                      *ngFor="let sub of status.status.subs"
                    >
                      <p>{{ convertDateFormat(sub.created_at) }}</p>
                      <p class="sub-status">{{ sub.text }}</p>
                    </div>
                  </div>
                </div>

                <div
                  class="timeline-item finished-item"
                  *ngIf="statusHistory.length < 3"
                >
                  <div class="timeline-badge">3</div>
                  <div class="timeline-content">
                    <h3>Análise concluída</h3>
                    <div
                      class="d-flex flex-row align-items-start justify-content-between"
                      style="width: 70%"
                    >
                      <p></p>
                      <p class="sub-status"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="notes-container">
              <div class="notes-label title-label">ANOTAÇÕES</div>
              <hr style="background-color: #c8bfff; margin: 1rem 0" />
              <div class="notes-content">
                <div class="note" *ngFor="let note of notes">
                  {{ note.message }}

                  <div class="details">
                    <span>{{ formatTimestamp(note.datetime) }}</span>
                    <span>{{ note.user_name }}</span>
                  </div>
                </div>
              </div>

              <div class="selected-files-preview"></div>

              <div
                class="d-flex flex-column align-items-center"
                *ngIf="loadingNotes"
              >
                <mat-spinner [diameter]="60"></mat-spinner>
              </div>

              <div class="chat-input" *ngIf="!loadingNotes">
                <label for="opFileInput" class="mt-2" style="cursor: pointer">
                  <img src="assets/icons/attachImg.svg" alt="" />

                  <input
                    type="file"
                    id="opFileInput"
                    accept=".jpeg, .png, .mp4"
                    (change)="onFileSelected($event)"
                    style="display: none"
                  />
                </label>

                <input
                  type="text"
                  placeholder="Escreva um comentário..."
                  class="message-input"
                  [value]="commentMessage"
                  (input)="updateCommentMessage($event.target.value)"
                  (keyup.enter)="sendComment()"
                />
                <button class="send-button" (click)="sendComment()">
                  <img src="assets/icons/send.svg" alt="" />
                </button>
              </div>

              <div class="d-flex flex-column" style="margin-top: 1rem">
                <span style="font-weight: 500; color: #323033"
                  >IMAGENS ANEXADAS ({{ opMediasCount }})</span
                >
                <div class="comments-spinner" *ngIf="loadingMedia">
                  <mat-spinner diameter="64"></mat-spinner>
                </div>
                <div class="files-preview" *ngIf="!loadingMedia"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
